import React from 'react';

import styled from 'react-emotion';
import t from '@jetshop/intl';

import { Header, Matches, Wrapper } from './SearchPage';

const Headline = styled('h2')`
  display: block;
  font-size: 1.5rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 1.5rem;
`;

const EmptySearchResults = ({ term, result }) => {
  const total = 0;
  return (
    <Wrapper>
      <Headline>{t('Search result')}</Headline>
      <Header>
        <Matches>
          {t('{total, plural, =1 {# item} other {# items}}', {
            total,
            term
          })}
        </Matches>
      </Header>
    </Wrapper>
  );
};

export default EmptySearchResults;
